import { memo } from "react";
import { Text } from "src/components/elements/typography/Text";
import styles from "./styles.module.scss";

export const MypageSectionTitle = memo(({ children }: { children: string }) => {
  return (
    <h2>
      <Text size="size-30" weight="500" className={styles.text}>
        {children}
      </Text>
    </h2>
  );
});
